<script lang="ts">
    import { onMount } from "svelte";
    import { getPxFromStart } from "../scheduler";
    import type { ZoomRangeWithBlocks } from "../zoom2.svelte.js";

    type Props = {
        currentZoom: ZoomRangeWithBlocks;
    };
    let { currentZoom }: Props = $props();

    let now = $state(new Date());
    let leftPx = $derived(getPxFromStart(currentZoom, now));
    onMount(() => {
        const interval = setInterval(() => {
            now = new Date();
        }, 1000);
        return () => {
            clearInterval(interval);
        };
    });
    const getEndDisplayDate = (currentZoom: ZoomRangeWithBlocks) => {
        const blocksLen = currentZoom.blocks.length;
        if (blocksLen === 0) {
            throw new Error(
                "Tried to get end display date however no blocks were supplied within the current view store.",
            );
        }
        const lastBlock = currentZoom.blocks[blocksLen - 1];
        return lastBlock.end;
    };

    let endDate = $derived(getEndDisplayDate(currentZoom));
</script>

<div class="now-wrapper" style:--left={`${leftPx}px`}>
    {#if endDate > now}
        <div class="text">
            <p>Now</p>
        </div>
        <div class="line"></div>
    {/if}
</div>

<style lang="scss">
    .now-wrapper {
        opacity: 0.9;
        overflow: hidden;
        .text {
            position: absolute;
            left: var(--left);
            margin-top: 4rem;
            p {
                padding: 0.25rem 0.5rem;
                border-radius: 0.5rem;
                background-color: var(--clr-primary);
                color: var(--primary);
            }
        }
        .line {
            width: 3px;
            height: 100%;
            background-color: var(--chart-1);
            position: absolute;
            left: var(--left);
            box-shadow: -0.5rem 0 1rem 0rem var(--chart-1);
        }
    }
</style>
